import { useState } from 'react'
import { isTransportError } from '@krp/client-runtime'
import { firstOfMonth } from '@krp/ui-kit'
import { newUuid } from '@krp/platform-ui'
import { CashierLinksScreen, cashierGroupDraftPatched, cashierGroupsPatched, receiptsGroups, receiptsSaveGroup, receiptsCashierCandidates, receiptsGroupAudit, type CashierLinksDraft } from '@krp/resource-receipts-ui'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { SOURCE_KINDS } from '../../composition/connectionForms'

const errorText = (error: unknown) => isTransportError(error) ? error.message : error instanceof Error ? error.message : error === undefined ? null : 'Не удалось получить ответ сервера'
function currentMonth() {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Moscow', year: 'numeric', month: '2-digit' }).formatToParts(new Date())
  return firstOfMonth(`${parts.find((part) => part.type === 'year')?.value ?? ''}-${parts.find((part) => part.type === 'month')?.value ?? ''}-01`)
}
export function CashierLinksBinding() {
  const directory = receiptsGroups.useQuery()
  const dispatch = useAppDispatch()
  const intent = useAppSelector((state) => state.receipts.cashierGroups)
  const { draft } = intent
  const month = intent.month || currentMonth()
  const setDraft = (value: CashierLinksDraft | null) => { dispatch(cashierGroupsPatched({ draft: value })) }
  const setMonth = (value: string) => { dispatch(cashierGroupsPatched({ month: value })) }
  const [refresh, setRefresh] = useState(false)
  const [localError, setLocalError] = useState<string | null>(null)
  const [save, result] = receiptsSaveGroup.useMutation()
  const personId = draft !== null && draft.version > 0 ? draft.id : ''
  const audit = receiptsGroupAudit.useQuery(personId, { skip: personId === '' })
  const patch = (value: Partial<CashierLinksDraft>) => { dispatch(cashierGroupDraftPatched({ ...value, operationId: newUuid() })); result.reset() }
  /** Вызывается из строки пары как хук: у каждой строки свой источник и свой запрос кассиров. */
  const useCandidates = (resourceId: string) => {
    const query = receiptsCashierCandidates.useQuery({ resourceId, month, timeZoneId: 'Europe/Moscow', refresh }, { skip: resourceId === '' })
    return { candidates: query.currentData, loading: query.isFetching }
  }
  return <CashierLinksScreen directory={directory.data} kinds={SOURCE_KINDS} draft={draft} month={month} audit={audit.currentData} busy={result.isLoading}
    loading={directory.isFetching} error={localError ?? errorText(result.error ?? directory.error ?? audit.error)} saved={result.isSuccess}
    useCandidates={useCandidates}
    remove={(id) => {
      const person = directory.data?.people.find((item) => item.id === id)
      if (person === undefined || !person.canEdit) return
      setLocalError(null); result.reset()
      void save({ ...person, archived: true, operationId: newUuid(), month, timeZoneId: 'Europe/Moscow' }).unwrap().catch(() => undefined)
    }} choosePerson={(id) => {
      setLocalError(null); result.reset()
      if (id === 'new') { setDraft({ id: newUuid(), version: 0, name: '', archived: false, members: [], operationId: newUuid() }); return }
      const person = directory.data?.people.find((item) => item.id === id)
      if (person !== undefined && !person.canEdit) { setLocalError('Нужен доступ ко всем источникам этого человека для изменения связей'); return }
      setDraft(person === undefined ? null : { ...person, members: [...person.members], operationId: newUuid() })
    }} patch={patch}
    period={(value) => { if (/^\d{4}-\d{2}-01$/.test(value)) setMonth(value) }}
    save={() => {
      if (draft === null) return
      void save({ ...draft, month, timeZoneId: 'Europe/Moscow' }).unwrap().then(() => { setDraft(null) }).catch(() => undefined)
    }} reload={() => { void directory.refetch(); if (draft !== null) setRefresh(true) }} />
}
